<script>
export default {
    props: {
        translations: {
            type: Object | Array
        },
        translationsKeyPath: {
            type: String
        },
        translationsKeyPaths: {
            type: Array
        }
    }
}
</script>